import React from "react";
import Suitcase from "../assets/icons/suitcase.svg";
import Times from "../assets/icons/times-light.svg";
import CaretRight from "../assets/icons/caret-right.svg";
import { useGlobalState } from "../context/Global";

function Roles() {
  const { roles, tasksForRoleID, showAllTasks, setShowAllTasks } = useGlobalState();
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <div className="xl:pl-1">
      <button className="bg-primary-dark w-full py-4 font-bold text-white flex justify-center items-center " onClick={() => setIsOpen(true)}>
        <Suitcase className="fill-current mr-2" width="16" />
        Select your roles&nbsp;&nbsp;
        <CaretRight className="fill-current transform rotate-90 mt-1" width="8" />
      </button>
      {isOpen && (
        <div className="absolute left-0 top-0 w-full text-white z-10">
          <div className="bg-primary-dark py-4 pl-8 pr-4 flex justify-between items-center">
            <div className="flex">
              <Suitcase className="fill-current mr-2" width="16" />
              Select your roles
            </div>
            <Times className="fill-current cursor-pointer" width="16" onClick={() => setIsOpen(false)} />
          </div>

          <div onClick={() => setShowAllTasks(!showAllTasks)} className="bg-primary-bright border-b border-primary-dark py-4 pl-8 pr-2 flex items-center relative border-b border-gray-300">
            <div className="checkbox checkbox--orange">
              <input type="checkbox" checked={showAllTasks} readOnly />
              <span></span>
            </div>

            <div className="text-lg transform-uppercase ml-8 text-primary-dark">Enable all roles to view all tasks ({tasksForRoleID()?.length})</div>
          </div>

          {roles.map((r) => (
            <Role key={"role" + r.$.id} id={r.$.id} checked={r.checked} label={r._} />
          ))}
        </div>
      )}
    </div>
  );
}

const Role = ({ id, checked, label }) => {
  const { toggleRole, tasksForRoleID, showAllTasks } = useGlobalState();
  return (
    <div className="bg-gray-100 py-4 pl-8 pr-2 flex items-center border-b border-gray-300" onClick={() => !showAllTasks && toggleRole(id)}>
      <div className="flex-shrink-0">
        <div className="checkbox checkbox--orange">
          <input type="checkbox" checked={checked} disabled={showAllTasks} readOnly />
          <span></span>
        </div>
      </div>
      <div className="text-lg transform-uppercase ml-8 text-black">
        {label} <span className="text-secondary-dark">({tasksForRoleID(id)?.length})</span>
      </div>
    </div>
  );
};

export default Roles;
